import {Balance, BalanceRepository} from '../../domain/BalanceRepository';
import {getAuthHeader} from '@infra/api/authManager/authManager';
import {fetch} from '@infra/api/fetch';
import {DEFAULT_HEADERS} from '@infra/domain/model/_utils/defaultHeaders';

export interface BalanceApiResponse {
  amount: number;
}

export const ApiBalanceRepository: BalanceRepository = {
  getBalance: async (): Promise<Balance> => {
    const authHeader = await getAuthHeader();
    const response = await fetch(`/balance/v1/balance`, {
      method: 'GET',
      headers: {
        ...authHeader,
        ...DEFAULT_HEADERS,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch balance');
    }

    const balanceResponse: BalanceApiResponse = await response.json();

    return {
      amount: balanceResponse.amount,
    };
  },
  redeemBalance: async (balanceCode, device) => {
    const authHeader = await getAuthHeader();

    try {
      const result = await fetch('/api/v1/redeemBalance', {
        method: 'POST',
        body: JSON.stringify({
          promocode: balanceCode,
          device,
          service: 'box',
        }),
        headers: {
          ...authHeader,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });

      const response = await result.json();
      if (!result.ok) {
        return Promise.reject(response);
      }
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
